import PropTypes from 'prop-types';
import { useI18n } from '../../../../../context/I18nContext';
import { JOIN_RULES, HISTORY_VISIBILITY } from '../../../../../constants/roomSettings';
import './SecurityPage.css';

const SecurityPage = ({
  isDM = false,
  isEncrypted = false,
  joinRule = JOIN_RULES.INVITE,
  historyVisibility = HISTORY_VISIBILITY.JOINED,
  onJoinRuleChange = () => {},
  onHistoryVisibilityChange = () => {},
  canConfigure = false,
  userPowerLevel = 0,
}) => {
  const { t } = useI18n();
  // Only show "Visible for everyone" for public, non-encrypted rooms that are not DMs
  const showWorldReadable = joinRule === JOIN_RULES.PUBLIC && !isDM && !isEncrypted;
  
  // Only show visibility section if user has power level >= 100
  const showVisibilitySection = userPowerLevel >= 100;
  
  return (
    <div className="room-settings-page">
      <div className="room-settings-section">
        <div className="room-settings-section-header">
          <h3 className="room-settings-section-title">{t('RoomSettings.securityTitle')}</h3>
          <div className="room-settings-section-divider" />
        </div>
        <div className="room-settings-option-group">
          <label className="room-settings-option">
            <input
              id="room-settings-join-rule-public"
              type="radio"
              name="joinRule"
              value={JOIN_RULES.PUBLIC}
              checked={joinRule === JOIN_RULES.PUBLIC}
              onChange={(e) => onJoinRuleChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">{t('RoomSettings.joinRulePublicLabel')}</span>
              <span className="room-settings-option-description">
                {t('RoomSettings.joinRulePublicDesc')}
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              id="room-settings-join-rule-invite"
              type="radio"
              name="joinRule"
              value={JOIN_RULES.INVITE}
              checked={joinRule === JOIN_RULES.INVITE}
              onChange={(e) => onJoinRuleChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">{t('RoomSettings.joinRuleInviteLabel')}</span>
              <span className="room-settings-option-description">
                {t('RoomSettings.joinRuleInviteDesc')}
              </span>
            </div>
          </label>
        </div>
      </div>

      {showVisibilitySection && <div className="room-settings-section">
        <div className="room-settings-section-header">
          <h3 className="room-settings-section-title">{t('RoomSettings.historyVisibilityTitle')}</h3>
          <div className="room-settings-section-divider" />
        </div>
        <div className="room-settings-option-group">
          <label className="room-settings-option">
            <input
              id="room-settings-history-visibility-invited"
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.INVITED}
              checked={historyVisibility === HISTORY_VISIBILITY.INVITED}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">{t('RoomSettings.historyVisibilityInvitedLabel')}</span>
              <span className="room-settings-option-description">
                {t('RoomSettings.historyVisibilityInvitedDesc')}
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              id="room-settings-history-visibility-joined"
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.JOINED}
              checked={historyVisibility === HISTORY_VISIBILITY.JOINED}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">{t('RoomSettings.historyVisibilityJoinedLabel')}</span>
              <span className="room-settings-option-description">
                {t('RoomSettings.historyVisibilityJoinedDesc')}
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              id="room-settings-history-visibility-shared"
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.SHARED}
              checked={historyVisibility === HISTORY_VISIBILITY.SHARED}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">{t('RoomSettings.historyVisibilitySharedLabel')}</span>
              <span className="room-settings-option-description">
                {t('RoomSettings.historyVisibilitySharedDesc')}
              </span>
            </div>
          </label>

          {showWorldReadable && (
            <label className="room-settings-option">
              <input
                id="room-settings-history-visibility-world-readable"
                type="radio"
                name="historyVisibility"
                value={HISTORY_VISIBILITY.WORLD_READABLE}
                checked={historyVisibility === HISTORY_VISIBILITY.WORLD_READABLE}
                onChange={(e) => onHistoryVisibilityChange(e.target.value)}
                disabled={!canConfigure}
              />
              <div className="room-settings-option-content">
                <span className="room-settings-option-label">{t('RoomSettings.historyVisibilityWorldReadableLabel')}</span>
                <span className="room-settings-option-description">
                  {t('RoomSettings.historyVisibilityWorldReadableDesc')}
                </span>
              </div>
            </label>
          )}
        </div>
      </div>}
    </div>
  );
};

SecurityPage.propTypes = {
  isDM: PropTypes.bool,
  isEncrypted: PropTypes.bool,
  joinRule: PropTypes.string,
  historyVisibility: PropTypes.string,
  onJoinRuleChange: PropTypes.func,
  onHistoryVisibilityChange: PropTypes.func,
  canConfigure: PropTypes.bool,
  userPowerLevel: PropTypes.number,
};

export default SecurityPage;
